 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"view-auth-TokenLogin-vue":"view-auth-TokenLogin-vue","view-auth-Verify-vue":"view-auth-Verify-vue","view-offers-ClaimOffer-vue":"view-offers-ClaimOffer-vue","view-offers-ClaimSwayOffer-vue~view-proofs-ProofPhotoUpload-vue":"view-offers-ClaimSwayOffer-vue~view-proofs-ProofPhotoUpload-vue","view-offers-ClaimSwayOffer-vue":"view-offers-ClaimSwayOffer-vue","view-offers-Coupon-vue~view-offers-Offers-vue~view-offers-VoucherSwayOffer-vue~view-proofs-ProofPhot~188b0624":"view-offers-Coupon-vue~view-offers-Offers-vue~view-offers-VoucherSwayOffer-vue~view-proofs-ProofPhot~188b0624","view-proofs-ProofPhotoUpload-vue":"view-proofs-ProofPhotoUpload-vue","view-offers-Coupon-vue":"view-offers-Coupon-vue","view-offers-Offers-vue":"view-offers-Offers-vue","view-offers-VoucherSwayOffer-vue":"view-offers-VoucherSwayOffer-vue","view-offers-EnteredSwayOffer-vue":"view-offers-EnteredSwayOffer-vue","view-offers-Voucher-vue":"view-offers-Voucher-vue","view-user-MyOffers-vue":"view-user-MyOffers-vue","view-user-Profile-Communication-vue":"view-user-Profile-Communication-vue","view-user-Profile-Personal-vue":"view-user-Profile-Personal-vue","view-user-Profile-Social-vue":"view-user-Profile-Social-vue","view-user-Profile-Support-vue":"view-user-Profile-Support-vue","view-user-Profile-vue":"view-user-Profile-vue","view-user-Signup-vue":"view-user-Signup-vue"}[chunkId]||chunkId) + "." + {"chunk-fe86895a":"36013500","view-auth-TokenLogin-vue":"2e46cf2b","view-auth-Verify-vue":"e59657df","view-offers-ClaimOffer-vue":"70166042","view-offers-ClaimSwayOffer-vue~view-proofs-ProofPhotoUpload-vue":"e1b59a20","view-offers-ClaimSwayOffer-vue":"b2c8ff04","view-offers-Coupon-vue~view-offers-Offers-vue~view-offers-VoucherSwayOffer-vue~view-proofs-ProofPhot~188b0624":"0572b2bd","view-proofs-ProofPhotoUpload-vue":"55b468d4","view-offers-Coupon-vue":"b6b6edce","view-offers-Offers-vue":"86fa064f","view-offers-VoucherSwayOffer-vue":"82b70af4","view-offers-EnteredSwayOffer-vue":"8e0650a8","view-offers-Voucher-vue":"bbd1e286","view-user-MyOffers-vue":"4a7cce85","view-user-Profile-Communication-vue":"84807535","view-user-Profile-Personal-vue":"c88718b9","view-user-Profile-Social-vue":"dfa79557","view-user-Profile-Support-vue":"672310e4","view-user-Profile-vue":"94348001","view-user-Signup-vue":"9e728013"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-fe86895a":1,"view-auth-Verify-vue":1,"view-offers-ClaimOffer-vue":1,"view-offers-ClaimSwayOffer-vue":1,"view-offers-Coupon-vue":1,"view-offers-Offers-vue":1,"view-offers-VoucherSwayOffer-vue":1,"view-offers-EnteredSwayOffer-vue":1,"view-offers-Voucher-vue":1,"view-user-MyOffers-vue":1,"view-user-Profile-vue":1,"view-user-Signup-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"view-auth-TokenLogin-vue":"view-auth-TokenLogin-vue","view-auth-Verify-vue":"view-auth-Verify-vue","view-offers-ClaimOffer-vue":"view-offers-ClaimOffer-vue","view-offers-ClaimSwayOffer-vue~view-proofs-ProofPhotoUpload-vue":"view-offers-ClaimSwayOffer-vue~view-proofs-ProofPhotoUpload-vue","view-offers-ClaimSwayOffer-vue":"view-offers-ClaimSwayOffer-vue","view-offers-Coupon-vue~view-offers-Offers-vue~view-offers-VoucherSwayOffer-vue~view-proofs-ProofPhot~188b0624":"view-offers-Coupon-vue~view-offers-Offers-vue~view-offers-VoucherSwayOffer-vue~view-proofs-ProofPhot~188b0624","view-proofs-ProofPhotoUpload-vue":"view-proofs-ProofPhotoUpload-vue","view-offers-Coupon-vue":"view-offers-Coupon-vue","view-offers-Offers-vue":"view-offers-Offers-vue","view-offers-VoucherSwayOffer-vue":"view-offers-VoucherSwayOffer-vue","view-offers-EnteredSwayOffer-vue":"view-offers-EnteredSwayOffer-vue","view-offers-Voucher-vue":"view-offers-Voucher-vue","view-user-MyOffers-vue":"view-user-MyOffers-vue","view-user-Profile-Communication-vue":"view-user-Profile-Communication-vue","view-user-Profile-Personal-vue":"view-user-Profile-Personal-vue","view-user-Profile-Social-vue":"view-user-Profile-Social-vue","view-user-Profile-Support-vue":"view-user-Profile-Support-vue","view-user-Profile-vue":"view-user-Profile-vue","view-user-Signup-vue":"view-user-Signup-vue"}[chunkId]||chunkId) + "." + {"chunk-fe86895a":"06a0cd1c","view-auth-TokenLogin-vue":"31d6cfe0","view-auth-Verify-vue":"65d33bfa","view-offers-ClaimOffer-vue":"600e2087","view-offers-ClaimSwayOffer-vue~view-proofs-ProofPhotoUpload-vue":"31d6cfe0","view-offers-ClaimSwayOffer-vue":"6b52a489","view-offers-Coupon-vue~view-offers-Offers-vue~view-offers-VoucherSwayOffer-vue~view-proofs-ProofPhot~188b0624":"31d6cfe0","view-proofs-ProofPhotoUpload-vue":"31d6cfe0","view-offers-Coupon-vue":"f731cdb7","view-offers-Offers-vue":"dda619f4","view-offers-VoucherSwayOffer-vue":"c319d7f8","view-offers-EnteredSwayOffer-vue":"19651f1b","view-offers-Voucher-vue":"06e0e7c5","view-user-MyOffers-vue":"a47ce172","view-user-Profile-Communication-vue":"31d6cfe0","view-user-Profile-Personal-vue":"31d6cfe0","view-user-Profile-Social-vue":"31d6cfe0","view-user-Profile-Support-vue":"31d6cfe0","view-user-Profile-vue":"ec5b5549","view-user-Signup-vue":"65d33bfa"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
